module.exports = __webpack_public_path__ + "static/media/judoclub.aa9a6f65.jpeg";